import React from 'react';

function SubsDetail() {
  return <div>subsdetail</div>;
}

export default SubsDetail;
